import { useContext, useEffect, useMemo } from "react";
import { TablaDinamica } from "../../components/TablaDinamica";
import { DetalleCandidata } from "../../models/monitoreo/DetalleCandidata";
import { RiesgoPerfilContext } from "./RiesgoPerfil";
import { useLazyParams } from "../../hooks/useLazyParams";

export const TablaDetalleCandidata = ({ matriz, monitoreoSrv, generic, toast, setError, getRol, fechaInicio, fechaFin }) => {
    const { nivelesAlerta, procedimientosControl, justificaciones } = useContext(RiesgoPerfilContext);
    const DetallesModel = useMemo(() => new DetalleCandidata().model, []);
    const tablaEstadoDetalles = useLazyParams({ modelo: DetallesModel, initialRows: 5 });

    const opcionesJustificacion = useMemo(() => justificaciones?.map(j => ({ label: j.nombre, value: j.cat_id })) || [], [justificaciones]);
    const opcionesControl = useMemo(() => procedimientosControl?.map(p => ({ label: p.nombre, value: p.cat_id })) || [], [procedimientosControl]);
    const nivelesDeAlertaOptions = useMemo(() => nivelesAlerta?.map(a => ({ label: a.nombre, value: a.sigla, back_color: a.color_bg })) || [], [nivelesAlerta]);

    const catalogosTabla = {
        alertas: nivelesDeAlertaOptions,
        procedimientos: opcionesControl,
        justificaciones: opcionesJustificacion
    };

    useEffect(() => {
        if (!matriz?.id) return;
        tablaEstadoDetalles.setLoading(true);
        let _lazyParams = { ...tablaEstadoDetalles.lazyParams };
        if (getRol()) { _lazyParams.rol = getRol(); }

        const payload = {
            lazyEvent: JSON.stringify(_lazyParams),
            matriz_id: matriz.id,
            fecha_inicio: fechaInicio, // Tipos distintos enviados, uno en ListaRiesgo y otro en RiesgoPerfilCalendario
            fecha_fin: fechaFin,
        };

        monitoreoSrv.consultarInfo('monitoreo/nivel-riesgo-perfil/listar-detalles-candidatas', payload).then(res => {
            tablaEstadoDetalles.setData(res.data.registros);
            tablaEstadoDetalles.setTotalRecords(res.data.total);
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            tablaEstadoDetalles.setLoading(false);
        });

        // eslint-disable-next-line
    }, [tablaEstadoDetalles.lazyParams, matriz.id]);

    return (
        <div style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderLeft: '5px solid #3b82f6', borderRadius: '8px', padding: '1.5rem', margin: '0.5rem 1rem', boxShadow: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)' }}>
            <div className="flex align-items-center mb-3">
                <div className="flex align-items-center justify-content-center bg-blue-100 border-round p-2 mr-3">
                    <i className="pi pi-users text-blue-600 text-xl"></i>
                </div>
                <div className="flex flex-column">
                    <span className="text-500 text-sm font-semibold uppercase">Perfiles analizados en la matriz</span>
                    <span className="text-900 text-lg font-bold">{matriz.nombre} <span className="text-500 font-normal">({matriz.codigo})</span></span>
                </div>
                <span className="ml-auto bg-blue-50 text-blue-700 font-bold px-3 py-1 border-round">
                    Total: {tablaEstadoDetalles.totalRecords}
                </span>
            </div>
            <div className="bg-white border-round p-2 border-1 surface-border shadow-1">
                <TablaDinamica modelo={DetallesModel} estadoTabla={tablaEstadoDetalles} datos={tablaEstadoDetalles.data} totalRegistros={tablaEstadoDetalles.totalRecords} dataKey="id" catalogos={catalogosTabla} />
            </div>
        </div>
    );
};
